import './Loader.css'
const Loader = ({isLoading}) => {
  return isLoading && (
    <div className="loader-container">
      <div className="loader">
        <div className="spinner"></div>
        <p>Please wait...</p>
      </div>
    </div>
  );
};
export default Loader;
